import { render, staticRenderFns } from "./LKMunMehFormView.vue?vue&type=template&id=10c8bf31&"
import script from "./LKMunMehFormView.vue?vue&type=script&lang=js&"
export * from "./LKMunMehFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports